<template>
  <div>
    <!-- Main Layout Content -->
    <div class="d-flex flex-column flex-root app-root" id="kt_app_root">
      <div class="app-page flex-column flex-column-fluid" id="kt_app_page">
        <HeaderComponent />
        <div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
          <SidebarComponent />
          <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
            <router-view />
            <FooterComponent />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponent from "../components/Header.vue";
import SidebarComponent from "../components/Sidebar.vue";
import FooterComponent from "../components/Footer.vue";

export default {
  name: "MainLayout",
  mounted() {
    document.body.setAttribute("id", "kt_app_body");
    document.body.setAttribute("data-kt-app-layout", "dark-sidebar");
    document.body.setAttribute("data-kt-app-header-fixed", "true");
    document.body.setAttribute("data-kt-app-sidebar-enabled", "true");
    document.body.setAttribute("data-kt-app-sidebar-fixed", "true");
    document.body.setAttribute("data-kt-app-sidebar-hoverable", "true");
    document.body.setAttribute("data-kt-app-sidebar-push-header", "true");
    document.body.setAttribute("data-kt-app-sidebar-push-toolbar", "true");
    document.body.setAttribute("data-kt-app-sidebar-push-footer", "true");
    document.body.setAttribute("data-kt-app-toolbar-enabled", "true");
    document.body.className = "app-default";
  },
  beforeUnmount() {
    document.body.removeAttribute("id");
    document.body.removeAttribute("data-kt-app-layout");
    document.body.removeAttribute("data-kt-app-header-fixed");
    document.body.removeAttribute("data-kt-app-sidebar-enabled");
    document.body.removeAttribute("data-kt-app-sidebar-fixed");
    document.body.removeAttribute("data-kt-app-sidebar-hoverable");
    document.body.removeAttribute("data-kt-app-sidebar-push-header");
    document.body.removeAttribute("data-kt-app-sidebar-push-toolbar");
    document.body.removeAttribute("data-kt-app-sidebar-push-footer");
    document.body.removeAttribute("data-kt-app-toolbar-enabled");
    document.body.className = "";
  },
  components: {
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
  },
};
</script>

<style scoped></style>
